import React from "react";
import PropTypes from "prop-types";

import AfghanistanMapLoader from "./AfghanistanMapLoader.js";
import AustraliaMapLoader from "./AustraliaMapLoader.js";
import ChinaMapLoader from "./ChinaMapLoader.js";
import EasternEuropeMapLoader from "./EasternEuropeMapLoader.js";
import IraqMapLoader from "./IraqMapLoader.js";
//import RussiaMapLoader from "./RussiaMapLoader.js";
import ThailandMapLoader from "./ThailandMapLoader.js";
import USAMapLoader from "./USAMapLoader.js";
import USPoliticsMapLoader from "./USPoliticsMapLoader.js";
import USATexas23MapLoader from "./USATexas23MapLoader.js";
import VenezuelaMapLoader from "./VenezuelaMapLoader.js";

const MapLoader = (props) => {	
	switch (props.baseMap) {
		case "iraq": {
			return <IraqMapLoader {...props} noTimeline={props.noTimeline} />;
		}
		case "craftsman":
		case "usip": {
			return <AfghanistanMapLoader {...props} noTimeline={props.noTimeline} />;
		}
		case "gec":
		case "balticsDemo":
		case "gec_analyst":
		case "oseRussia": {
			return <EasternEuropeMapLoader {...props} noTimeline={props.noTimeline} />;
		}		
		case "nest": { 
			return <ThailandMapLoader {...props} noTimeline={props.noTimeline} />;
		}
		case "russia": {
			return <EasternEuropeMapLoader {...props} noTimeline={props.noTimeline} />;
			// return <RussiaMapLoader {...props} noTimeline={props.noTimeline} />;
		}
		case "texas23":
		case "sevenTwenty_uscc":
		case "uspol": {
			return <USATexas23MapLoader {...props} noTimeline={props.noTimeline} />;
		}
		case "politics2020": { 
			return <USPoliticsMapLoader {...props} noTimeline={props.noTimeline} />;
		}
		case "venezuela":
		case "sayara": {
			return <VenezuelaMapLoader {...props} noTimeline={props.noTimeline} />;
		}
		case "sevenTwenty":
		case "bcbs":
		case "dccc":
		case "walmart":
		case "midterms": {
			return <USAMapLoader {...props} noTimeline={props.noTimeline} />;
		}
		case "china": {
			return <ChinaMapLoader {...props} noTimeline={props.noTimeline} validMapIds={["China"]} />;
		}
		case "australia2022": 
		case "oseAusChina":
		case "koala": {
			const mapIds = ["China", "Australia"];
			switch (props.currentMapId) {
				case "Australia": {
					return <AustraliaMapLoader {...props} noTimeline={props.noTimeline} validMapIds={mapIds} />;
				}
				default: {
					return <ChinaMapLoader {...props} noTimeline={props.noTimeline} validMapIds={mapIds} />;
				}
			}
		}
		default: {
			return <USAMapLoader {...props} noTimeline={props.noTimeline} />;
		}
	}
};

MapLoader.defaultProps = {
	baseMap: null,
	noTimeline: true,
};

MapLoader.propTypes = {
	baseMap: PropTypes.string,
	noTimeline: PropTypes.bool,
	currentMapId: PropTypes.string,
	validMapIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default MapLoader;
